/**
 * Rahmen eines gewaehlten Zeitraums.
 *
 * Ein Zeitraum bekommt genau einen durchgehenden Rahmen ueber alle seine Tage — pro Zelle
 * gezeichnete Rahmen ergaeben doppelte Kanten zwischen benachbarten Tagen. Die Marke
 * „Zeitraum N" sitzt dagegen an jeder Zelle, damit sie auch am Rand des Fensters lesbar bleibt.
 */
export function SelectionOverlay({ gridStart, span }: { gridStart: number; span: number }) {
  return (
    <div
      className="pointer-events-none relative z-20 p-0.5"
      style={{ gridColumn: `${gridStart} / span ${span}`, gridRow: 1 }}
    >
      <div className="border-forest h-full w-full rounded-md border-2" />
    </div>
  );
}
